/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.10
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InternalCommonUserPhotoFromJSON, InternalCommonUserPhotoToJSON, } from './InternalCommonUserPhoto';
/**
 * Check if a given object implements the InternalCommonUserBase interface.
 */
export function instanceOfInternalCommonUserBase(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('subNetworkIds' in value) || value['subNetworkIds'] === undefined)
        return false;
    if (!('extendedUpdatedAt' in value) || value['extendedUpdatedAt'] === undefined)
        return false;
    if (!('photo' in value) || value['photo'] === undefined)
        return false;
    return true;
}
export function InternalCommonUserBaseFromJSON(json) {
    return InternalCommonUserBaseFromJSONTyped(json, false);
}
export function InternalCommonUserBaseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'email': json['email'],
        'name': json['name'],
        'subNetworkIds': json['sub_network_ids'],
        'extendedUpdatedAt': (json['extended_updated_at'] == null ? null : new Date(json['extended_updated_at'])),
        'photo': InternalCommonUserPhotoFromJSON(json['photo']),
    };
}
export function InternalCommonUserBaseToJSON(json) {
    return InternalCommonUserBaseToJSONTyped(json, false);
}
export function InternalCommonUserBaseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'email': value['email'],
        'name': value['name'],
        'sub_network_ids': value['subNetworkIds'],
        'extended_updated_at': (value['extendedUpdatedAt'].toISOString()),
        'photo': InternalCommonUserPhotoToJSON(value['photo']),
    };
}
